import type { ProcedureType } from "@overmap-ai/common"
import { FileHandlePlugin, FileHandler, type FileHandlerOptions } from "@tiptap/extension-file-handler"
import { PluginKey } from "@tiptap/pm/state"

import { sdk } from "../../../sdk"
import { ProcedureTypeAttachmentNode } from "../../nodes"

interface ProcedureTypeFileHandlerOptions extends Pick<FileHandlerOptions, "allowedMimeTypes"> {
	uuid: ProcedureType["uuid"]
}

export const ProcedureTypeFileHandler = FileHandler.extend<ProcedureTypeFileHandlerOptions>({
	name: "ProcedureTypeFileHandler",
	addProseMirrorPlugins() {
		return [
			FileHandlePlugin({
				key: new PluginKey(this.name),
				editor: this.editor,
				allowedMimeTypes: this.options.allowedMimeTypes,
				onDrop: async (editor, files, pos) => {
					const [offlineAttachments] = await sdk.procedureTypeAttachments.bulkAdd(
						files.map((file) => ({
							procedure_type: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContentAt(
							pos,
							offlineAttachments.map((offlineAttachment) => ({
								type: ProcedureTypeAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
				onPaste: async (editor, files) => {
					const [offlineAttachments] = await sdk.procedureTypeAttachments.bulkAdd(
						files.map((file) => ({
							procedure_type: this.options.uuid,
							file,
						})),
					)

					editor
						.chain()
						.focus()
						.insertContent(
							offlineAttachments.map((offlineAttachment) => ({
								type: ProcedureTypeAttachmentNode.name,
								attrs: {
									uuid: offlineAttachment.uuid,
								},
							})),
						)
						.run()
				},
			}),
		]
	},
})
